import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { applyColor }from '~src/style/ColorService';

export const outterDivStyles: React.CSSProperties = {
  textAlign: 'center',
  position: 'absolute',
  minWidth: '500px',
  top: '15%',
  right: '0',
  bottom: '0',
  left: '0'
};

export const errorMessageStyles: React.CSSProperties = {
  fontSize: '18px',
  fontWeight: 'bold',
  color: applyColor(DesignTokens.color.font.default.error, TabStyles.Colors.AttentionDark),
  marginBottom: TabStyles.Spacing.LargeSpace
};

export const messageStyles: React.CSSProperties = {
  color: applyColor(DesignTokens.color.font.default.default, '#333'),
  fontSize: '18px'
};

export const linkStyles: React.CSSProperties = {
  display: 'block',
  marginTop: TabStyles.Spacing.ExtraLargeSpace*3
};

export const undoButtonStyles: React.CSSProperties = {
  marginTop: TabStyles.Spacing.MediumSpace
};
